import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Langue déduite de l'URL : /en/... = anglais, sinon français.
export const useLang = () => {
  const { pathname } = useLocation();
  const lang = pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr";
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return lang;
};

// Chemin localisé : lp("en", "/crisopea") -> "/en/crisopea"
export const lp = (lang, path) =>
  lang === "en" ? (path === "/" ? "/en" : "/en" + path) : path;

// Chemin sans préfixe de langue (pour la détection de thème, le switcher…)
export const stripLang = (pathname) =>
  pathname === "/en" ? "/" : pathname.replace(/^\/en\//, "/");

// Champ produit localisé : loc(p, "en", "ambiance") -> p.en.ambiance ?? p.ambiance
export const loc = (p, lang, key) =>
  (lang === "en" && p?.en && p.en[key] != null ? p.en[key] : p?.[key]);
